import { Container } from 'react-bootstrap'


export const Footer = () => {
    return (
        <footer className='footer'>
            <Container>
                <p className='text-center'>&copy; 2022 Richard Li</p>
            </Container>
        </footer>
    )
}